import { ClinicSettings } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { Person } from "@/Common/Models/Person/Person";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { OntarioPatientEnrollment } from "./Ontario/OntarioPatientEnrollment";
import { QuebecPatientEnrollment } from "./Quebec/QuebecPatientEnrollment";

interface IPatientEnrollmentProps {
    patientId: string;
    quebecModel: IPatientEnrollmentModel;
    activeSite: SitesModel;
    clinicSettings: ClinicSettings;
    getPhysician: (contactFacetId: string) => Person;
}

class PatientEnrollment extends React.Component<IPatientEnrollmentProps, any> {
    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        if (this.props.clinicSettings.EnableOntarioPatientEnrollment && this.props.activeSite?.isSiteInProvince(CanadaState.Ontario))
            return (
                <OntarioPatientEnrollment
                    patientId={this.props.patientId}
                    getPhysician={this.props.getPhysician}
                />
            );

        return <QuebecPatientEnrollment model={this.props.quebecModel} />;
    }
}

export { PatientEnrollment };
